exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ms-Dialog-main._2VPvu5w5CtASz29Heu2cRo{min-width:600px}._3cEK0SNadSjU8kQrg03vhv{width:100%}._3jxfhZlpfSrMnYCCvS7UJ0{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}.-yH7486Tqh7MaTvpgajOo{min-width:250px;width:100%}html[dir] .-yH7486Tqh7MaTvpgajOo{margin:5px 0}", ""]);

// exports
exports.locals = {
	"linkDialog": "_2VPvu5w5CtASz29Heu2cRo",
	"linkContent": "_3cEK0SNadSjU8kQrg03vhv",
	"linkLabel": "_3jxfhZlpfSrMnYCCvS7UJ0",
	"linkInput": "-yH7486Tqh7MaTvpgajOo"
};